var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"data-svg-lvl-3":"spread-block-contour","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 514 430"}},[_c('defs'),_c('g',{attrs:{"id":"Контур"}},[_c('polygon',{staticClass:"lc-c-3",attrs:{"points":"67.57 72.08 67.57 203.7 67.57 203.7 67.57 335.32 446.32 335.32 446.32 203.7 446.32 203.7 446.32 72.08 67.57 72.08"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }